module.exports = __webpack_public_path__ + "a94ec432242e443143e010c0342ded56.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/accessibility/largePrint.svg
// module id = vFe4
// module chunks = 0